import React from "react";

const SvgHighBellGraph = (props) => (
  <svg width={91} height={57} {...props}>
    <defs>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="High_Bell_Graph_svg__c"
      >
        <stop stopColor="#0CB2FF" offset="0%" />
        <stop stopColor="#057BFF" offset="100%" />
      </linearGradient>
      <filter
        x="-33.2%"
        y="-39.2%"
        width="166.2%"
        height="248.6%"
        filterUnits="objectBoundingBox"
        id="High_Bell_Graph_svg__a"
      >
        <feMorphology
          radius={1.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset dy={12} in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feMorphology radius={1.5} in="SourceAlpha" result="shadowInner" />
        <feOffset dy={12} in="shadowInner" result="shadowInner" />
        <feComposite
          in="shadowOffsetOuter1"
          in2="shadowInner"
          operator="out"
          result="shadowOffsetOuter1"
        />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.470588235 0 0 0 0 0.564705882 0 0 0 0 0.611764706 0 0 0 0.243716033 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <path
        d="M68.986 30.496c-4.234-.978-7.378-2.473-9.433-4.485C56.47 22.993 51.99 8.746 44.208 3.375c-7.783-5.372-13.934-5.16-21.888 6.759-7.954 11.92-7.368 12.463-10.873 15.877C9.111 28.287 5.295 30.241 0 31.875"
        id="High_Bell_Graph_svg__b"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M80.245 36h-21.73l-.864-25.968c.576 0 1.122-.17 1.64-.51.518-.34.978.352 1.38 2.078l3.484 2.245 4.426 7.703.942 1.676.76 2.302 1.728.9 2.332 3.987 6.641 3.086-.74 2.501z"
        fill="#0091FF"
        opacity={0.209}
      />
      <g
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(11 2)"
      >
        <use
          fill="#000"
          filter="url(#High_Bell_Graph_svg__a)"
          xlinkHref="#High_Bell_Graph_svg__b"
        />
        <use
          stroke="url(#High_Bell_Graph_svg__c)"
          strokeWidth={3}
          xlinkHref="#High_Bell_Graph_svg__b"
        />
      </g>
    </g>
  </svg>
);

export default SvgHighBellGraph;
